import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesPlusOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M1 12C1 3.25 2.375 2 12 2s11 1.25 11 10h-1.8c0-2.172-.088-3.734-.328-4.889-.233-1.125-.577-1.7-.973-2.06-.417-.379-1.109-.72-2.424-.945C16.155 3.88 14.394 3.8 12 3.8s-4.154.08-5.475.306c-1.315.225-2.007.566-2.424.945-.396.36-.74.935-.973 2.06C2.888 8.266 2.8 9.828 2.8 12s.088 3.734.328 4.889c.233 1.125.577 1.7.973 2.06.417.379 1.109.72 2.424.945 1.32.226 3.081.306 5.475.306V22C2.375 22 1 20.75 1 12"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 24a5 5 0 1 0 0-10 5 5 0 0 0 0 10m-.9-8v2.1H16v1.8h2.1V22h1.8v-2.1H22v-1.8h-2.1V16z"
                    fill="currentColor"
                />
                <path d="M6 11.1h6v1.8H6z" fill="currentColor" />
                <path d="M6 8.9V7.1h12v1.8z" fill="currentColor" />
            </g>
        </svg>
    )
);
CardLinesPlusOutlinedSize24Glyph.displayName = 'CardLinesPlusOutlinedSize24Glyph';
